import React, { Component, Fragment } from 'react'
import { Flex } from 'reflexbox'
import { mapProps, compose } from 'recompose'
import { IconButton } from 'react-toolbox/lib/button'
import T from 'i18n-react'

import { ROUTE_ROLES } from 'containers/Role/constants'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import notifyHoc from 'containers/App/Notification/Notify'
import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'


const showToTeam = compose(
  mapProps((props) => ({
    ...props,
    roles: [ 
      ROUTE_ROLES.DATA_MANAGER
    ]
  })),
  showOnAnyRoles
)

const EditButton = showToTeam(IconButton)
const InfoButton = showToTeam(notifyHoc(IconButton))

const Actions = ({isLoading, editMode, onSubmit, toggleEditMode, toggleCollapse, toggleRevisionDialog, toggleImportDialog, collapse}) => {
  return (
    <Flex justify='flex-end'>
      {editMode ? (
        <Fragment>
          <InfoButton
            icon='import_export'
            onClick={() => toggleImportDialog()}
            message={T.translate('product.view.notification.importRevision')}
            disabled={isLoading}
          />
          <InfoButton
            icon='list'
            onClick={() => toggleRevisionDialog()}
            message={T.translate('product.view.notification.changeRevision')}
            disabled={isLoading}
          />
          <EditButton
            icon='save'
            onClick={() => onSubmit()}
            disabled={isLoading}
          />
        </Fragment>
      ) : (
        <EditButton
          icon='edit'
          onClick={() => toggleEditMode(!editMode)}
          disabled={isLoading}
        />
      )
      }
      <CollapseIconButton
        toggleCollapse={() => toggleCollapse}
        collapse={collapse}
      />
    </Flex>
  )
}

export default Actions
